import styles from "./MarkdownDocument.module.css";

export default function Markdown({ result }: any) {
  const { htmlContent } = result.data;
  return (
    <div className="AppLayout">
      <div
        className={styles.MarkdownDocument}
        dangerouslySetInnerHTML={{ __html: htmlContent.html }}
      />
    </div>
  );
}
